export default __webpack_public_path__ + "static/media/ATR3.960971bf.pdf";